module.exports = __webpack_public_path__ + "static/media/undraw_login_v483.23825b9b.svg";